// Native session token store. WKWebView/Android WebView drop the backend's
// cross-site cookie, so native builds authenticate with `Authorization: Bearer`.
// Web keeps using the httpOnly cookie and never stores a token.
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const KEY = "balagha_session_token";
export const isNative = Capacitor.isNativePlatform();
export const nativePlatform = Capacitor.getPlatform(); // ios | android | web

let token = isNative ? localStorage.getItem(KEY) : null;

export const getSessionToken = () => token;

export const authHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});

// Preferences survives app restarts even if iOS evicts WebView storage.
export async function loadSessionToken() {
  if (!isNative) return null;
  const { value } = await Preferences.get({ key: KEY });
  if (value) {
    token = value;
    localStorage.setItem(KEY, value);
  }
  return token;
}

export async function setSessionToken(value) {
  if (!isNative) return;
  token = value || null;
  if (token) {
    localStorage.setItem(KEY, token);
    await Preferences.set({ key: KEY, value: token });
  } else {
    localStorage.removeItem(KEY);
    await Preferences.remove({ key: KEY });
  }
}
